import api from "./client";

export const getQuotes = (params) => api.get("/quotes", { params });
export const getQuote = (quoteId) => api.get(`/quotes/${quoteId}`);
export const createQuote = (data) => api.post("/quotes", data);
export const updateQuote = (quoteId, data) => api.patch(`/quotes/${quoteId}`, data);
export const updateQuoteStatus = (quoteId, status, { skip_emails } = {}) =>
  api.patch(`/quotes/${quoteId}/status`, null, {
    params: { status, ...(skip_emails !== undefined && { skip_emails }) },
  });
export const deleteQuote = (quoteId) => api.delete(`/quotes/${quoteId}`);
export const undoQuoteRejection = (quoteId) => api.post(`/quotes/${quoteId}/undo-rejection`);
export const rejectAlternatives = (quoteId, sendDeclineEmails, { spareQuoteIds, scopeEnquiryIds } = {}) =>
  api.post(`/quotes/${quoteId}/reject-alternatives`, null, {
    params: {
      send_decline_emails: sendDeclineEmails,
      ...(spareQuoteIds?.length ? { spare_quote_ids: spareQuoteIds.join(",") } : {}),
      ...(scopeEnquiryIds?.length ? { scope_enquiry_ids: scopeEnquiryIds.join(",") } : {}),
    },
  });
export const previewQuotesEmail = (quoteIds) =>
  api.post("/quotes/preview", { quote_ids: quoteIds });
export const sendQuotesBatch = (quoteIds, { subject, html, sender_email, from_name, recipient_email, new_thread, cc, attach_presentation, slide_overrides } = {}) =>
  api.post("/quotes/send", { quote_ids: quoteIds, subject, html, sender_email, from_name, recipient_email, new_thread, cc, attach_presentation, slide_overrides });
export const generatePresentation = (quoteIds) =>
  api.post("/quotes/generate-presentation", { quote_ids: quoteIds });
export const previewSlides = (quoteIds) =>
  api.post("/quotes/preview-slides", { quote_ids: quoteIds });
export const previewMultiSegmentQuotesEmail = (parentEnquiryId, quoteIds) =>
  api.post("/quotes/preview-multi-segment", { parent_enquiry_id: parentEnquiryId, quote_ids: quoteIds });
export const sendMultiSegmentQuotes = (parentEnquiryId, quoteIds, { subject, html, sender_email, from_name, recipient_email, new_thread, cc, attach_presentation, slide_overrides } = {}) =>
  api.post("/quotes/send-multi-segment", { parent_enquiry_id: parentEnquiryId, quote_ids: quoteIds, subject, html, sender_email, from_name, recipient_email, new_thread, cc, attach_presentation, slide_overrides });
export const markQuoteAsSentExternally = (quoteId) =>
  api.post(`/quotes/${quoteId}/mark-as-sent`);
export const sendQuoteFollowup = (quoteId, { subject, body_html }) =>
  api.post(`/quotes/${quoteId}/follow-up`, { subject, body_html });
export const getFxRate = (from, to) =>
  api.get("/fx/rate", { params: { from, to } });
// Rates that turn each currency into `to` (house rate first, then live).
export const getDisplayFxRates = (to, currencies) =>
  api.get("/fx/rates", { params: { to, currencies: (currencies || []).join(",") || undefined } });
// Package quotes: several units from one supplier sent as one quote.
export const createQuotePackage = (quoteIds, { quantities, label } = {}) =>
  api.post("/quotes/packages", { quote_ids: quoteIds, quantities, label });
export const getQuotePackage = (packageId) => api.get(`/quotes/packages/${packageId}`);
export const unpackQuotePackage = (packageId) => api.delete(`/quotes/packages/${packageId}`);
